import { MantineProvider } from '@mantine/core';
import { StytchProvider } from '@stytch/react';
import { stytch } from './auth/stytch';
import { CustomFlagsmithProvider } from './provider/Flagsmith';
import { RouterAndStateCache } from './router/main';
import { resolveTheme } from './theme/ResolveTheme';

const App = () => {
  return (
    <CustomFlagsmithProvider>
      <MantineProvider
        theme={resolveTheme}
        withGlobalStyles
        withNormalizeCSS
      >
        <StytchProvider stytch={stytch}>
          <RouterAndStateCache />
        </StytchProvider>
      </MantineProvider>
    </CustomFlagsmithProvider>
  );
};

export default App;
